<div class="row" *ngIf="pspes.settingPointStoreProduct != null">
	<div class="col-12 fake-card mx-auto pt-3">
		<div class="row">
			<div class="col-6">
				<div class="form-group pb-4">
					<div class="form-check mb-2 d-flex">
						<input class="form-check-input mr-2" type="checkbox" value=""
							id="settingPointStoreProductCarousel" [(ngModel)]="pspes.settingPointStoreProduct.Carousel"
							(ngModelChange)="checkboxChanged_showInCarousel();" />
						<label class="form-check-label" for="settingPointStoreProductCarousel">
							<span cvLocalizedText langSection="MarketPlace_Management" langKey="Show_Home_Page">Show
								listing products on home page's carousel</span>
						</label>
					</div>

					<div class="d-flex mb-3">
						<div class="w-50">
							<cv-baremetrics-calendar class="d-block daterange daterange--single"
								[ngClass]="{'baremetrics-disabled': !pspes.settingPointStoreProduct.Carousel}"
								[required]="isCarouselRequired()"
								[(currentDate)]="pspes.modifiedPointStoreProduct.CarouselStart"
								(dateChanged)="setCarouselStart($event)" mode="single"></cv-baremetrics-calendar>
							<label for="" class="mb-0 color-theUpsideDown font-size-12" cvLocalizedText langSection="MarketPlace_Management" langKey="Start_Date_Summary">Start Date</label>
						</div>
						<div class="w-50">
							<cv-baremetrics-calendar class="d-block daterange daterange--single"
								[ngClass]="{'baremetrics-disabled': !pspes.settingPointStoreProduct?.Carousel}"
								[required]="false" [(currentDate)]="pspes.modifiedPointStoreProduct.CarouselEnd"
								(dateChanged)="setCarouselEnd($event)" mode="single"></cv-baremetrics-calendar>
							<label for="" class="mb-0 color-theUpsideDown font-size-12" cvLocalizedText langSection="MarketPlace_Management" langKey="End_Date_Summary">End Date</label>
						</div>
					</div>
				</div>

				<div class="form-group pb-4">
					<div class="form-check d-flex">
						<input class="form-check-input mr-2" type="checkbox" value=""
							id="settingPointStoreProductFeaturedProduct"
							[(ngModel)]="pspes.settingPointStoreProduct.FeaturedProduct"
							(ngModelChange)="checkboxChanged_showInFeatured();" />
						<label class="form-check-label" for="settingPointStoreProductFeaturedProduct">
							<span cvLocalizedText langSection="MarketPlace_Management"
								langKey="List_As_Featured">Feature product's listing on home page</span>
						</label>
					</div>

					<div class="d-flex mb-3">
						<div class="w-50">
							<cv-baremetrics-calendar class="d-block daterange daterange--single"
								[ngClass]="{'baremetrics-disabled': !pspes.settingPointStoreProduct?.FeaturedProduct}"
								[required]="isFeaturedRequired()"
								[(currentDate)]="pspes.modifiedPointStoreProduct.FeatureStart"
								(dateChanged)="setFeatureStart($event)" mode="single"></cv-baremetrics-calendar>
							<label for="" class="mb-0 color-theUpsideDown font-size-12" cvLocalizedText langSection="MarketPlace_Management" langKey="Start_Date_Summary">Start Date</label>
						</div>
						<div class="w-50">
							<cv-baremetrics-calendar class="d-block daterange daterange--single"
								[ngClass]="{'baremetrics-disabled': !pspes.settingPointStoreProduct?.FeaturedProduct}"
								[required]="false" [(currentDate)]="pspes.modifiedPointStoreProduct.FeatureEnd"
								(dateChanged)="setFeatureEnd($event)" mode="single"></cv-baremetrics-calendar>
							<label for="" class="mb-0 color-theUpsideDown font-size-12" cvLocalizedText langSection="MarketPlace_Management" langKey="End_Date_Summary">End Date</label>
						</div>
					</div>
				</div>

				<div class="form-group pb-4">
					<div class="form-check d-flex" *ngIf="!pspes.modifiedPointStoreProduct.HasProductVariations">
						<input class="form-check-input mr-2" type="checkbox" value="" id="putOnSale"
							[(ngModel)]="pspes.settingPointStoreProduct.Sale"
							(ngModelChange)="checkboxChanged_OnSale();" />
						<label cvLocalizedText langSection="MarketPlace_Management" langKey="Put_On_Sale" class="form-check-label" for="putOnSale">
							Put on Sale
						</label>
					</div>

					<div class="" *ngIf="pspes.modifiedPointStoreProduct.HasProductVariations">
						<hr style="width: 428px; border: none; border-top: 1px solid #E0E3E6; margin-bottom: 8px;" />
						<label cvLocalizedText langSection="MarketPlace_Management" langKey="Variations_Sale" class="font-size-16 color-theUpsideDown">Variations Sale</label>
						<div class="form-check d-flex" style="margin-bottom: 8px;">
							<input class="form-check-input mr-2" type="checkbox" [(ngModel)]="selectAll"
								(ngModelChange)="checkAll()" />
							<label cvLocalizedText langSection="MarketPlace_Management" langKey="All_Variations" class="form-check-label font-size-14 color-theUpsideDown lato-bold" for="">All
								Variations</label>
						</div>
						<div class="form-check d-flex" style="margin-bottom: 8px;"
							*ngFor="let variation of pspes.modifiedPointStoreProduct.VariationsData">
							<input class="form-check-input mr-2" type="checkbox" [(ngModel)]="variation.VariationOnSale"
								(ngModelChange)="checkboxChanged_VariationOnSale();" />
							<label class="form-check-label color-theUpsideDown variationNameLabel"
								title="{{variation.VariationName}}" for="">{{variation.VariationName}}</label>
						</div>
					</div>

					<div class="pb-2">
						<label cvLocalizedText langSection="MarketPlace_Management" langKey="Sales_Percentage" for="" class="mb-0 color-theUpsideDown font-size-12">Sales Percentage</label>
						<input class="form-control w-25" type="number" placeholder="%"
							id="input-sale-percentage"
							[min]="minSalesPorcentage" [max]="maxSalesPorcentage" (keypress)="numberOnly($event)" (paste)="(false)" maxlength = "2" (input)="maxLengthCheck($event)"
							[(ngModel)]="pspes.modifiedPointStoreProduct.Sale" [disabled]="!checkSale()"
							(ngModelChange)="checkboxChanged_OnSale(); validateZero()" (keydown)="getOldValue($event); maxLengthCheck($event)"
							(keyup)="checkIntFieldValidation($event); maxLengthCheck($event)" />
					</div>
					<div class="d-flex">
						<div class="w-50">
							<cv-baremetrics-calendar class="d-block daterange daterange--single"
								[ngClass]="{'baremetrics-disabled': !checkSale()}"
								[required]="checkSale()"
								[(currentDate)]="pspes.modifiedPointStoreProduct.SaleStart"
								(dateChanged)="setSaleStart($event)" mode="single"></cv-baremetrics-calendar>
							<label for="" class="mb-0 color-theUpsideDown font-size-12" cvLocalizedText langSection="MarketPlace_Management" langKey="Start_Date_Summary">Start Date</label>
						</div>
						<div class="w-50">
							<cv-baremetrics-calendar class="d-block daterange daterange--single"
								[ngClass]="{'baremetrics-disabled': !checkSale()}" [required]="false"
								[(currentDate)]="pspes.modifiedPointStoreProduct.SaleEnd"
								(dateChanged)="setSaleEnd($event)" mode="single"></cv-baremetrics-calendar>
							<label for="" class="mb-0 color-theUpsideDown font-size-12" cvLocalizedText langSection="MarketPlace_Management" langKey="End_Date_Summary">End Date</label>
						</div>
					</div>
				</div>
			</div>

			<div class="col-6">
				<div class="text-center pb-3">
					<span cvLocalizedText langSection="MarketPlace_Management" langKey="Home_Page_Preview">Home Page Preview</span>
					<img [src]="getPreviewImage()" class="img-fluid" />
				</div>
				<div class="text-center">
					<span cvLocalizedText langSection="MarketPlace_Management" langKey="Product_Page_Preview">Product Page Preview</span>
					<img [src]="'../App_Themes/clearview-default/images/gamification/marketplace/layout-options/' + (pspes.settingPointStoreProduct?.Sale ? 'Y' : 'NNN') + 'B.png'"
						class="img-fluid" />
				</div>
			</div>
		</div>

		<div class="form-group row pt-3">
			<div class="col-12 d-flex justify-content-end">
				<button type="button" class="btn btn-text mr-2" (click)="cancel()">
					<span cvLocalizedText langSection="MarketPlace_Management" langKey="Cancel">Cancel</span>
				</button>
				<button type="button" class="btn btn-primary" (click)="maxLengthCheck(null); next(3)">
					<span cvLocalizedText langSection="MarketPlace_Management" langKey="Next">Next</span>
				</button>
			</div>
		</div>
	</div>

</div>